import { APP_INIT, APP_SHOW_ALERT, APP_HIDE_ALERT, APP_INIT_ROUTE_SET } from './types'

const init = async (ctx) => {
	try {
		ctx.commit(APP_INIT)
	} catch (e) {
		console.log(e)
	}
}

const showAlert = async (ctx, payload) => {
	try {
		ctx.commit(APP_SHOW_ALERT, payload)
	} catch (e) {
		console.log(e)
	}
}

const hideAlert = async (ctx, message = '') => {
	try {
		ctx.commit(APP_HIDE_ALERT, message)
	} catch (e) {
		console.log(e)
	}
}

const setInitRoute = async (ctx, payload) => {
	try {
		ctx.commit(APP_INIT_ROUTE_SET, payload)
	} catch (e) {
		console.error(e)
		throw e
	}
}

export default {
	init,
	showAlert,
	hideAlert,
	setInitRoute
}
